export default __webpack_public_path__ + "static/media/customer3.432c7350.svg";